import { Form } from '@deere/ux.uxframe-react';
import { Table as UxTable } from '@deere/ux.uxframe-react'
import { findAnswerIndex, getTranslation } from '../utils/utils';
import { useTranslation } from "react-i18next";

export default function TableSection({ question, updateAnswer, answers, section, checkedProprietary }) {
    const { t } = useTranslation();
    return (
        <div>
            <Form.Group>
                <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
            </Form.Group>
            <UxTable size="sm" borderless>
                <tbody>
                    <tr>
                        {
                            question.dependentQuestions.map((q, index) => {
                                return <td key={index}>
                                    <Form.Group>
                                        <Form.Label className="uxf-label">{getTranslation(q, 'text')}</Form.Label>
                                        <Form.Control required={!checkedProprietary} as='select' onChange={(e) => updateAnswer(e, q.id)} className="custom-select" data-testid={q.id}
                                            value={findAnswerIndex(q.id, answers) >= 0 ? answers[findAnswerIndex(q.id, answers)].answer : ''}
                                            name={`${section}-${q.id}`}>
                                            <option value=''>{t('lbl_dropdown_select')}</option>
                                            {q.selections ? q.selections.sort((a, b) => (a.value > b.value) ? 1 : -1).map(opt => <option key={opt.id} value={opt.value}>{getTranslation(opt, 'text')}</option>) : null}
                                        </Form.Control>
                                        <div className="invalid-feedback">
                                            {t('bs_required')}
                                        </div>
                                    </Form.Group>
                                </td>
                            })
                        }
                    </tr>
                </tbody>
            </UxTable>
        </div>
    )
}